var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEyeIcon = function SvgEyeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.293 5.56c-.996.83-1.693 1.807-2.045 2.365L2.2 8l.047.075c.352.558 1.05 1.535 2.045 2.366.993.829 2.237 1.476 3.707 1.476 1.47 0 2.715-.647 3.708-1.476.995-.83 1.692-1.808 2.045-2.366L13.8 8a8.945 8.945 0 0 0-.047-.075c-.353-.558-1.05-1.535-2.045-2.366C10.715 4.73 9.47 4.083 8 4.083c-1.47 0-2.714.647-3.707 1.476ZM3.33 4.407c1.162-.97 2.736-1.825 4.67-1.825 1.933 0 3.506.855 4.668 1.825 1.16.968 1.955 2.086 2.352 2.716l.017.026c.078.123.187.294.242.533.044.194.044.44 0 .633-.055.24-.164.41-.242.534l-.017.026c-.397.63-1.192 1.748-2.352 2.716-1.162.97-2.735 1.825-4.669 1.825-1.933 0-3.507-.855-4.669-1.825-1.16-.968-1.954-2.086-2.352-2.716L.963 8.85C.885 8.727.776 8.556.72 8.316a1.522 1.522 0 0 1 0-.633c.055-.239.164-.41.242-.533l.016-.026c.398-.63 1.192-1.748 2.352-2.716Zm4.67 2.342a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM5.25 8a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Z",
    fill: "currentColor"
  })));
};

export default SvgEyeIcon;